import * as turf from "@turf/turf"

export const BRUSH_PIXEL_RADIUS = 28

export function getSegmentCircleIntersection(segmentStart, segmentEnd, circleCenter, circleRadius) {
    const startInside = isPointInsideCircle(segmentStart, circleCenter, circleRadius)
    const endInside = isPointInsideCircle(segmentEnd, circleCenter, circleRadius)

    if (startInside && endInside) {
        return [0, 1]
    }

    const intersectionParams = findCircleIntersectionParams(segmentStart, segmentEnd, circleCenter, circleRadius)

    if (intersectionParams.length === 0) {
        return []
    }

    const insideRange = []

    if (startInside) {
        insideRange.push(0)
    }

    insideRange.push(...intersectionParams)

    if (endInside) {
        insideRange.push(1)
    }

    if (insideRange.length >= 2) {
        return [insideRange[0], insideRange[insideRange.length - 1]].sort((a, b) => a - b)
    }

    return []
}

function isPointInsideCircle(point, circleCenter, circleRadius) {
    const dx = point[0] - circleCenter[0]
    const dy = point[1] - circleCenter[1]
    const distanceSquared = dx * dx + dy * dy
    return distanceSquared <= circleRadius * circleRadius
}

function findCircleIntersectionParams(segmentStart, segmentEnd, circleCenter, circleRadius) {
    const dx = segmentEnd[0] - segmentStart[0]
    const dy = segmentEnd[1] - segmentStart[1]

    // Quadratic coefficients for parametric line-circle intersection
    const a = dx * dx + dy * dy
    const b = 2 * (dx * (segmentStart[0] - circleCenter[0]) + dy * (segmentStart[1] - circleCenter[1]))
    const c = (segmentStart[0] - circleCenter[0]) ** 2 + (segmentStart[1] - circleCenter[1]) ** 2 - circleRadius ** 2

    const discriminant = b * b - 4 * a * c

    if (discriminant <= 0) {
        return []
    }

    const sqrtDiscriminant = Math.sqrt(discriminant)
    const t1 = (-b + sqrtDiscriminant) / (2 * a)
    const t2 = (-b - sqrtDiscriminant) / (2 * a)

    const validParams = []
    if (t1 >= 0 && t1 <= 1) {
        validParams.push(t1)
    }
    if (t2 >= 0 && t2 <= 1) {
        validParams.push(t2)
    }

    return validParams
}

export function computeBrushRadius(map, mouseEvent) {
    const pixelCoords = mouseEvent.point
    const brushBorderPixelCoords = {
        x: pixelCoords.x + BRUSH_PIXEL_RADIUS,
        y: pixelCoords.y,
    }
    const brushBorderCoord = map.unproject(brushBorderPixelCoords)
    return Math.abs(brushBorderCoord.lng - map.unproject(mouseEvent.point).lng)
}

export function extractCoordinatesBetweenDistances(roadFeature, startDistance, endDistance) {
    const startPoint = turf.along(roadFeature, startDistance).geometry.coordinates
    const endPoint = turf.along(roadFeature, endDistance).geometry.coordinates

    const coordinates = [startPoint]

    let cumulativeLength = 0
    for (let i = 0; i < roadFeature.geometry.coordinates.length - 1; i++) {
        const segmentLine = turf.lineString([
            roadFeature.geometry.coordinates[i],
            roadFeature.geometry.coordinates[i + 1],
        ])
        const segmentLength = turf.length(segmentLine)
        const nextCumulativeLength = cumulativeLength + segmentLength

        if (nextCumulativeLength > startDistance && nextCumulativeLength < endDistance) {
            coordinates.push(roadFeature.geometry.coordinates[i + 1])
        }

        cumulativeLength = nextCumulativeLength
    }

    coordinates.push(endPoint)

    return coordinates
}
